import { Injectable } from '@angular/core';
import { PatientGroupCommands } from 'src/app/data/dietitian/domain/patient_group/patient_group_commands';
import { Patient } from 'src/app/data/patient/domain/patient';

@Injectable()
export class PatientGroupPatientListFacade {
  constructor(private patientGroupCommands: PatientGroupCommands) {
    // do nothing
  }

  getPatientGroupPatients(
    dietitianId: string,
    patientGroupId: string,
  ): Promise<Patient[]> {
    return this.patientGroupCommands.getPatientGroupPatients(
      dietitianId,
      patientGroupId,
      false,
    );
  }
}
